import React, { useEffect, useLayoutEffect } from "react";

const News = () => {
  useLayoutEffect(() => {
    // Load TradingView timeline widget
    const script = document.createElement("script");
    script.src = "https://s3.tradingview.com/external-embedding/embed-widget-timeline.js";
    script.async = true;
    script.innerHTML = JSON.stringify({
      feedMode: "all_symbols",
      isTransparent: true,
      displayMode: "regular",
      width: "100%",
      height: "100%",
      colorTheme: "light",
      locale: "en"
    });
    document.getElementById("news-container").appendChild(script);
  }, []);

  return (
    <div className="container" >
      <h2 className="text-xl font-bold mb-1" style={{ color: 'var(--tittle-text)'  }} >Global Market News</h2>
      <div className="tradingview-widget-container">
        <div id="news-container" className="tradingview-widget-container__widget mb-5" style={{ height: "80vh", borderTop: '1px solid gray', borderBottom: '1px solid gray', overflow: 'hidden', backgroundColor: 'var(--ticker-bg)'  }}></div>

      </div>

    </div>
    
  );
};

export default News;
